// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609040935/js/" + chunkId + "." + {"44":"157ab130","225":"21b30d85","481":"d3f7b6d4","486":"5cd2e1ec","770":"288049aa"}[chunkId] + ".0.41775868213629597.chunk.js";
};